<section
  class="upload-file__section"
  [class.disabled]="isDisabled"
>
  <favie-local-spinner [componentId]="UploadingSpinnerId">
    <input
      type="file"
      accept="image/png,image/jpeg,image/png,application/pdf"
      hidden
      #fileInputElement
      (change)="onUploadedFile($event)"
    />

    <div class="preview-file-container">
      <div
        *ngIf="canUpload"
        class="preview-file w-100"
      >
        <div class="btn-import" (click)="triggerUpload()">
          <div class="icon">
            <img *ngIf="iconUrl" [src]="iconUrl"/>
          </div>

          <span *ngIf="label" class="label">{{ label }}</span>
        </div>
      </div>

      <ng-container *ngIf="file">
        <div class="preview-file__content">
          <a
            target="_blank"
            class="preview-file__file"
            [class.modified]="isModifiedFromReviewEdition"
            [href]="file.url"
          >{{ prefixFileName ? prefixFileName + '_' : '' }} {{ file?.file?.name }}</a>

          <div class="preview-file__actions" [class.pointer-events-none]="isDisabled">
            <i class="preview-file__action icon-cancel-circle w-5" (click)="remove()"></i>
          </div>
        </div>
      </ng-container>
    </div>
  </favie-local-spinner>
</section>
